import http from '@/utils/request';

/**  ------------- 收款退款 ----------------- */
/**
 * 退款审核列表
 *
 * @param {*} data
 * @returns
*/
export const getRefundList = (data = {}) => {
  const url = '/receipt/refund/bopList';
  return http.post({
    url,
    data,
  });
};

/**
 * 退款审核列表-退款审核操作
 *
 * @param {*} data
 * @returns
*/
export const setRefundApproval = (data = {}) => {
  const url = '/receipt/refund/approval';
  return http.post({
    url,
    data,
  });
};

/**
 * 退款审核列表-退款批量审核操作
 *
 * @param {*} data
 * @returns
*/
export const setRefundBatchApproval = (data = {}) => {
  const url = '/receipt/refund/batchApproval';
  return http.post({
    url,
    data,
  });
};

/**
 * 退款审核列表-退款详情
 *
 * @param {*} data
 * @returns
*/
export const getRefundDetail = (data = {}) => {
  const url = '/receipt/refund/detail';
  return http.post({
    url,
    data,
  });
};

// 收款退款导出
export const EXPORT_REFUND = '/receipt/export/refund';


/** ------------------  付款退款 --------------------- */

// 付款退款审核列表
export const getPaymentRefund = (data = {}) => {
  const url = '/payment/refund/bopList';
  return http.post({
    url,
    data,
  });
};

// 付款退款审核-退款审核操作（单个/批量）
export const setPayRefundBatchApproval = (data = {}) => {
  const url = '/payment/refund/batchApproval';
  return http.post({
    url,
    data,
  });
};

// 付款退款审核-退款详情
export const getPayRefundDetail = (data = {}) => {
  const url = '/payment/refund/detail';
  return http.post({
    url,
    data,
  });
};

/** ------------------  退款审核 --------------------- */

// 退款申请列表
export const getApplyBopList = (data = {}) => {
  return http.post({
    url: '/finance-receipt-server/receipt/refund/applyBopList',
    data,
  });
};

// 退款申请详情
export const getApplyDetail = (data = {}) => {
  return http.post({
    url: '/receipt/refund/applyDetail',
    data,
  });
};

// 退款申请审核
export const setRRefundApproval = (data = {}) => {
  return http.post({
    url: '/receipt/refund/applyApproval',
    data,
  });
};

/** --------- 分割线 -------------- */
